import { LabelPicker, type LabelOption } from "@/components/labels/LabelPicker";
import { useLabelsQuery } from "@/hooks/useLeadLabels";
import { toggleLabelSelection } from "@/lib/label-selection";

type Props = {
  selected: string[];
  onChange: (labelIds: string[]) => void;
};


/**
 * Label filter for the Buzón.
 *
 * Binds the shared `LabelPicker` to the caller's local state and to the plain
 * label list rather than to `useLabelLeadCounts` — those counts are scoped to
 * the pipeline's filter set, so showing them here would state a number that has
 * nothing to do with what the Buzón is displaying.
 */
export function InboxLabelFilter({ selected, onChange }: Props): React.JSX.Element | null {
  const { data: labels } = useLabelsQuery();

  const options: LabelOption[] = (labels ?? []).map((l) => ({
    id: l.id,
    name: l.name,
    color: l.color,
  }));

  function toggle(labelId: string): void {
    onChange(toggleLabelSelection(selected, labelId));
  }

  return (
    <LabelPicker
      options={options}
      selected={selected}
      onToggle={toggle}
      onClear={() => onChange([])}
    />
  );
}
